import React, { memo, useState } from 'react'
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { setSession } from "../helper/UserProfile";
import { useNavigate } from "react-router-dom";
import { useAlert } from "react-alert";

const Login = memo(() => {
    const navigate = useNavigate();
    let alert = useAlert();
    const [loading, setLoading] = useState(false);

    const validationLogin = Yup.object().shape({
        usernamelog: Yup.string().required(""),
        passwordlog: Yup.string().required(""),
    });

    const formOptionsLogin = { resolver: yupResolver(validationLogin) };

    const {
        register: registerLogin,
        handleSubmit: handleSubmitLogin,
        formState: { errors: errorsLogin },
    } = useForm(formOptionsLogin);

    async function onSubmitLogin({ usernamelog, passwordlog }) {
        setLoading(true);

        fetch(`${process.env.REACT_APP_URL_API}/data/login`, {
            method: "POST",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                "Cache-Control": "no-cache",
                "Access-Control-Allow-Origin": "*",
            },
            body: JSON.stringify({
                user: usernamelog,
                pass: passwordlog,
            }),
        })
            .then((response) => {
                response.json()
            })
            .then((data) => {
                setSession("logged", true);
                            navigate("/admin");
                // console.log(data);
                // if (data.length > 0) {
                //     alert.show("Sesión iniciada espere...", {
                //         timeout: 3000,
                //         type: "success",
                //         onClose: () => {
                //             setSession("logged", true);
                //             navigate("/admin");
                //         },
                //     });
                // } else {
                //     setLoading(false);
                //     alert.show("Usuario o contraseña incorrectos", {
                //         timeout: 3000,
                //         type: "error",
                //     });
                // }
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
                alert.show("Ocurrió un error, por favor intenta de nuevo " + error, {
                    timeout: 3000,
                    type: "error",
                });
            });
    }

    var disabled = false;

    return (
        <div>
            <section className="vh-100">
                <div className="container-fluid h-custom">
                    <div className="row d-flex justify-content-center align-items-center h-100">
                        <div className="col-md-9 col-lg-6 col-xl-5">
                            <img src="logoInicial.png"
                                className="img-fluid" alt="Sample image" />
                        </div>
                        <div className="col-md-8 col-lg-6 col-xl-4 offset-xl-1">
                            <form onSubmit={handleSubmitLogin(onSubmitLogin)}>
                                <div className="form-outline">
                                    <label className="form-label" htmlFor="form3Example3">Usuario</label>
                                    <input type="text" id="form3Example3"
                                        placeholder="Ingresa tu usuario"
                                        {...registerLogin("usernamelog")}
                                        autoFocus
                                        className={`form-control ${disabled ? "disabledfield" : ""
                                            } ${errorsLogin.usernamelog ? "is-invalid" : ""}`}
                                    />
                                    <div className="invalid-feedback">
                                        {errorsLogin === {}
                                            ? ""
                                            : "El nombre de usuario es requerido"}
                                    </div>
                                </div>

                                <div className="form-outline">
                                    <label className="form-label" htmlFor="form3Example4">Contraseña</label>
                                    <input type="password" id="form3Example4"
                                        {...registerLogin("passwordlog")}
                                        placeholder="Ingresa tu contraseña"
                                        className={`form-control ${disabled ? "disabledfield" : ""
                                            } ${errorsLogin.passwordlog ? "is-invalid" : ""}`}
                                    />
                                    <div className="invalid-feedback">
                                        {errorsLogin === {}
                                            ? ""
                                            : "La contraseña es requerida"}
                                    </div>
                                </div>

                                <div className="text-center text-lg-start mt-4 pt-2">
                                    <button type="submit" disabled={loading} className="btn btn-sm btn-primary btn-lg">Iniciar Sesión</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
})

export default Login